import { render, staticRenderFns } from "./charterersEdit.vue?vue&type=template&id=2c5339a4"
import script from "./charterersEdit.vue?vue&type=script&lang=js"
export * from "./charterersEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports